// Shared client constants. Extracted from api/client.ts (no behavior change).
// A leaf module so csrf + request can both read API_BASE without a cycle.

// Dev/prod topology is same-origin (Vite proxy / reverse proxy), so paths are
// relative and cookies ride automatically.
export const API_BASE = '/api/v1';
